export const PLACEHOLDER_LABEL_MAP = {
  '{department_insert}': 'Role',
  '{grade_insert}': 'Grade',
  '{department_and_grade_insert}': 'Role and Grade',
  '{full_name_insert}': 'Name',
};

export const NAME_PLACEHOLDER_KEY = '{full_name_insert}';
